import React from "react";

const ForefeitureOfShares = () => {
  return <div>ForefeitureOfShares</div>;
};

export default ForefeitureOfShares;
